export default __webpack_public_path__ + "static/image-670-79057cfcc403bbb89d102b6da4d0ef5c.png";